function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path fill="#0044F0" d="M2 4h20v2H2V4zM2 11h20v2H2v-2zM22 18H2v2h20v-2z"></path>
    </svg>
  );
}

export default Icon;
